import { Pipe, PipeTransform } from '@angular/core';
import { QarepaEnumInformation } from '@qarepa/common';

@Pipe({
  name: 'enumInfo',
  standalone: false,
})
export class EnumInfoPipe implements PipeTransform {
  transform<T extends string | number | symbol>(
    value: T,
    enumInfo: QarepaEnumInformation<T>
  ): string {
    return value && Object.prototype.hasOwnProperty.call(enumInfo, value)
      ? enumInfo[value].name
      : (value as unknown as string);
  }
}
